/**
 * @file Vue mixin to make component send user presence data to back end (for notification)
 */

import { Component, Vue } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'

const realtime = namespace('realtime')

@Component
export default class PresenceMixin extends Vue {
  intervalId
  @State((state): number => state.constants.presenceCallIntervalInSeconds) intervalInSeconds
  @realtime.Action absent
  @realtime.Action present

  listener(): void {
    if (document.visibilityState === 'visible') {
      this.present()
      this.intervalId = setTimeout((): void => this.present(), this.intervalInSeconds)
    } else {
      clearInterval(this.intervalId)
      this.absent()
    }
  }

  mounted(): void {
    document.addEventListener('visibilitychange', this.listener)
    this.listener()
  }

  beforeDestroy(): void {
    document.removeEventListener('visibilitychange', this.listener)
  }
}
